import React from 'react';

/**
 * Placeholder do EmployeeModal enquanto o chunk lazy carrega.
 */
export const EmployeeModalSkeleton: React.FC = () => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/20 backdrop-blur-sm animate-pulse"
    aria-busy="true"
    aria-label="Carregando formulário de colaborador"
  >
    <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden border border-slate-100">
      <div className="p-5 border-b border-slate-50 flex items-center gap-3">
        <div className="size-10 rounded-full bg-slate-200" />
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-slate-200 rounded w-40" />
          <div className="h-3 bg-slate-100 rounded w-28" />
        </div>
      </div>
      <div className="p-5 space-y-4">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="space-y-1.5">
            <div className="h-2.5 bg-slate-100 rounded w-20" />
            <div className="h-9 bg-slate-200 rounded-lg" />
          </div>
        ))}
        <div className="flex gap-2 pt-2">
          <div className="h-9 bg-slate-200 rounded-lg flex-1" />
          <div className="h-9 bg-slate-100 rounded-lg w-24" />
        </div>
      </div>
    </div>
  </div>
);
